var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0872 0C18.3176 0 17.8115 0.48575 17.8115 1.21933C17.8115 1.61586 17.8537 2.05204 17.8537 2.65675C17.8537 5.71995 16.6834 6.95911 13.4573 6.95911H6.95229L4.4747 7.10781L7.31075 4.68897L9.66183 2.45849C9.90432 2.2404 10.0625 1.943 10.0625 1.57621C10.0625 0.902107 9.52478 0.39653 8.76568 0.39653C8.43885 0.39653 8.11202 0.525403 7.8379 0.783147L0.921719 7.27633C0.658144 7.52416 0.5 7.86121 0.5 8.19827C0.5 8.53532 0.658144 8.88228 0.921719 9.1202L7.81682 15.6035C8.11202 15.8711 8.43885 16 8.76568 16C9.52478 16 10.0625 15.4944 10.0625 14.8203C10.0625 14.4634 9.90432 14.166 9.66183 13.938L7.31075 11.7076L4.48524 9.29864L6.95229 9.43742H13.6471C18.4336 9.43742 20.5 7.27633 20.5 2.70632C20.5 2.13135 20.4789 1.60595 20.3946 1.14002C20.2891 0.594796 19.9201 0 19.0872 0Z",
    fill: "#68899A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.cf63578ae3d85fff8c91b9bd68a6effc.svg";
export { ForwardRef as ReactComponent };